"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTitleBadge = useTitleBadge;
const react_1 = require("react");
function useTitleBadge(count, baseTitle) {
    // Mémorise le titre de base une seule fois
    const baseRef = (0, react_1.useRef)(baseTitle !== null && baseTitle !== void 0 ? baseTitle : document.title);
    (0, react_1.useEffect)(() => {
        const n = Number.isFinite(count) && count > 0 ? (count > 99 ? '99+' : String(count)) : '';
        document.title = n ? `(${n}) ${baseRef.current}` : baseRef.current;
        // Nettoyage : restaure le titre original si le composant est démonté
        return () => {
            document.title = baseRef.current;
        };
    }, [count]);
}
